module.exports = {
  about: 'About',
  activities: 'Activities',
  awards: 'Awards',
  hero_main: 'EI Fiesta',
  hero_sub: 'Broadening horizons with learning activities',
  btn_text: 'View activities',
  eieu: 'Entrepreneurship and Innovation Education Unit, EdUHK Library',
  tel: 'Tel',
  email: 'Email',
};